export const servicesMegaMenu = [
  {
    category: "General Dentistry",
    items: [
      { title: "Microscopic Root Canal Therapy", slug: "general-dentistry" },
      { title: "Filings under Microscope", slug: "root-canal-therapy" },
      { title: "Teeth Cleaning", slug: "crowns-and-bridges" },
      { title: "Crowns & Bridges", slug: "crowns-and-bridges" },
      { title: "Complete Dental", slug: "gum-treatment-periodontics" },
      { title: "Painless Teeth Extraction", slug: "crowns-and-bridges" },
    ],
  },
  {
    category: "Implant Dentistry",
    items: [
      { title: "Dental Implants", slug: "dental-implants" },
      { title: "All-on-Four", slug: "all-on-four" },
      { title: "Implant Supported FMR", slug: "implant-supported-fmr" },
    ],
  },
  {
    category: "Cosmetic Dentistry",
    items: [
      { title: "Teeth Whitening", slug: "teeth-whitening" },
      { title: "Veneers", slug: "veneers" },
      { title: "FMR (Tooth Supported)", slug: "fmr-tooth-supported" },
      { title: "Teeth Alignment", slug: "teeth-alignment-cosmetic" },
      { title: "Bridal Smile Makeover", slug: "bridal-smile-makeover" },
      { title: "Dental Jewelry and Tattoos", slug: "dental-jewelry-and-tattoos" },
    ],
  },
  {
    category: "More",
    items: [
      { title: "Dentistry for Kids", slug: "dentistry-for-kids" },
      { title: "Dental Tourism", slug: "dental-tourism" },
      {
        title: "Nervous Patient Care / Painless Dental Care",
        slug: "nervous-patient-care-painless-dental-care",
      },
      { title: "Geriatric Dentistry", slug: "geriatric-dentistry" },
      { title: "TMD (Jaw Pain)", slug: "tmd-jaw-pain" },
    ],
  },
  {
    category: "Smile Makeover",
    items: [
      { title: "Teeth Alignment", slug: "teeth-alignment-smile" },
      { title: "Invisalign", slug: "invisalign" },
    ],
  },
  // {
  //   category: "Technology",
  //   items: [
  //     { title: "Cerec Dentistry", slug: "cerec-dentistry" },
  //     { title: "Digital Dentistry", slug: "digital-dentistry" },
  //     { title: "Laser Dentistry", slug: "laser-dentistry" },
  //   ],
  // },
];

export const serviceSlugLookup = servicesMegaMenu.reduce((acc, section) => {
  section.items.forEach((item) => {
    acc[item.slug] = { title: item.title, category: section.category };
  });
  return acc;
}, {});
